"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var AddUp_exports = {};
__export(AddUp_exports, {
  default: () => AddUp_default
});
module.exports = __toCommonJS(AddUp_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4.57573 8.3229C4.34142 8.55721 4.34142 8.93711 4.57573 9.17143C4.81004 9.40574 5.18994 9.40574 5.42426 9.17143L8.15 6.44568L8.15 19.091C8.15 19.4224 8.41863 19.691 8.75 19.691C9.08137 19.691 9.35 19.4224 9.35 19.091L9.35 6.45037L12.0711 9.17143C12.3054 9.40574 12.6853 9.40574 12.9196 9.17143C13.1539 8.93711 13.1539 8.55721 12.9196 8.3229L9.24263 4.64594C8.96927 4.37258 8.52605 4.37258 8.25268 4.64594L4.57573 8.3229Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16 12.4C16.3314 12.4 16.6 12.6686 16.6 13V15.4002H19C19.3314 15.4002 19.6 15.6688 19.6 16.0002C19.6 16.3316 19.3314 16.6002 19 16.6002H16.6V19C16.6 19.3314 16.3314 19.6 16 19.6C15.6686 19.6 15.4 19.3314 15.4 19V16.6002H13C12.6686 16.6002 12.4 16.3316 12.4 16.0002C12.4 15.6688 12.6686 15.4002 13 15.4002H15.4V13C15.4 12.6686 15.6686 12.4 16 12.4Z",
      fill: "currentColor"
    }
  )
);
const SvgAddUp = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var AddUp_default = SvgAddUp;
